<template>
    <div class="bank-details">
        <div class="card-table rounded-bottom">
            <b-form role="form">
                <b-row>
                    <b-col md="8" cols="12">
                        <b-form-group label="Insurance Type">
                            <b-form-radio-group
                                required
                                v-model="form.product_type"
                                :options="productOptions"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Package">
                            <el-select v-model="form.package_name" placeholder="Select">
                                <el-option
                                    v-for="(item, index) in packageOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Company">
                            <el-select v-model="form.company_name" placeholder="Select">
                                <el-option
                                    v-for="(item, index) in companyOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Premium p.a (RM)">
                            <CurrencyInput
                                v-model="form.premium_pa"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Premium p.m (RM)">
                            <CurrencyInput
                                v-model="form.premium_pm"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Premium Cover (RM)">
                            <CurrencyInput
                                v-model="form.premium_cover"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Additional Cost">
                            <b-form-input
                            v-model="form.prod_ins_add_cost"
                            type="number"
                            step="0.01"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Paid By">
                            <el-select v-model="form.paid_by" placeholder="Select">
                                <el-option
                                    v-for="(item, index) in paymentOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Loan Officer">
                            <el-select v-model="form.prod_loan_officer_id" clearable filterable placeholder="Select Loan Officer" @change="loanOfficerDetails">
                                <el-option
                                v-for="loan_officer in userLoanOfficerList"
                                :key="loan_officer.id"
                                :label="loan_officer.name"
                                :value="loan_officer.id"
                                >
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Submission Date">
                            <b-form-input
                            v-model="form.prod_submitted_date"
                            type="date"
                            @change="onSubmissionDateChange"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12" v-if="isApprovedBank">
                        <b-form-group label="Approved Date">
                                <b-form-input
                                v-model="form.acceptance_date"
                                type="date"
                                ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Status">
                            <el-select v-model="form.status" placeholder="Select" :disabled="!checkAccess(['p_product__manage'])" @change="handleStatusChange(form.status)">
                                <el-option
                                    v-for="(item, index) in list_sub_insurance_status"
                                    :key="index"
                                    :label="item.status"
                                    :value="item.status"
                                ></el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <el-button class="bg-primary text-white" :loading="is_loading" @click="updateInsurance">Save</el-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton, Button } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import {
        notifyFunctionMixin,
        helperFunctionMixin,
        axios,
        services,
        getHeader,
        debounce
    } from '@/assets/js/httpImports.js'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import {INSURANCE_STATUS,INSURANCE_APPROVED_STATUS} from '@/assets/js/status.js'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { useProductStore } from '@/stores/productStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
    props: ['product'],
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        CurrencyInput,
        [Select.name]: Select,
        [Option.name]: Option,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
        [Button.name]: Button,
    },
    data() {
        return {
            prodSSADetails: null, 
            status:[],
            INSURANCE_STATUS:INSURANCE_STATUS,
            INSURANCE_APPROVED_STATUS:INSURANCE_APPROVED_STATUS,
            is_loading: false,
            form: {
                status: '',
                product_type: '',
                package_name: '',
                company_name: '',
                premium_pa: 0,
                premium_pm: 0,
                premium_cover: 0,
                paid_by: '',
                acceptance_date: null,
                prod_loan_officer_id:'',
                prod_submitted_date: null,
                prod_ins_add_cost: '',
            },
            productOptions: [
                { text: 'Investment Link', value: 'INVESTMENT_LINK' },
                { text: 'Life Insurance', value: 'LIFE_INSURANCE' }
            ],
            packageOptions: [
                {
                    value: 'Sunwira',
                    label: 'Sunwira'
                },
                {
                    value: 'Sun eSsential Life',
                    label: 'Sun eSsential Life'
                },
                {
                    value: 'Sun eSsential-i',
                    label: 'Sun eSsential-i'
                },
                {
                    value: 'Sun Legacy-i',
                    label: 'Sun Legacy-i'
                },
                {
                    value: 'Sun Prime Link-i',
                    label: 'Sun Prime Link-i'
                },
                {
                    value: 'Sun Wira',
                    label: 'Sun Wira'
                },
                {
                    value: 'Sun Heritage-i',
                    label: 'Sun Heritage-i'
                },
                {
                    value: 'Sun - Essentian-i',
                    label: 'Sun - Essentian-i'
                },
                {
                    value: 'FWD Insurance - 20 Years',
                    label: 'FWD Insurance - 20 Years',
                },
                {
                    value: 'FWD Insurance - 10 Years',
                    label: 'FWD Insurance - 10 Years',
                },
                {
                    value: 'Invinity Insurance',
                    label: 'Invinity Insurance',
                },
                {
                    value: 'MRTT',
                    label: 'MRTT',
                },
                {
                    value: 'MLTT',
                    label: 'MLTT',
                },
            ],
            companyOptions: [
                {
                    value: 'Sunlife',
                    label: 'Sunlife'
                },
                {
                    value: 'Manulife',
                    label: 'Manulife'
                },
                {
                    value: 'FWD Insurance BSN',
                    label: 'FWD Insurance BSN'
                },
            ],
            paymentOptions: [
                {
                    value: 'Credit Card - Auto Debit',
                    label: 'Credit Card - Auto Debit'
                },
                {
                    value: 'Transfer Bank',
                    label: 'Transfer Bank'
                },
                {
                    value: 'Cheques',
                    label: 'Cheques'
                },
                {
                    value: 'Cash',
                    label: 'Cash'
                },
                {
                    value: 'Payment Getaway',
                    label: 'Payment Getaway'
                },
                {
                    value: 'Auto debit from debit card',
                    label: 'Auto debit from debit card'
                },
                {
                    value: 'Not Applicable',
                    label: 'Not Applicable'
                },
                {
                    value: 'Standard Instruction',
                    label: 'Standard Instruction'
                },
            ],
        }
    },
    watch:{
        product: {
            handler(newVal){
                this.form.product_type = newVal.product_detail.prod_ins_type,
                this.form.package_name = newVal.product_detail.prod_ins_package,
                this.form.company_name = newVal.product_detail.prod_ins_company,
                this.form.premium_pa = parseFloat(newVal.product_detail.prod_ins_premium_pa),
                this.form.premium_pm = parseFloat(newVal.product_detail.prod_ins_premium_pm),
                this.form.premium_cover = parseFloat(newVal.product_detail.prod_ins_premium_cover),
                this.form.paid_by = newVal.product_detail.prod_ins_paid_by
                this.form.status = newVal.prod_status
                this.form.acceptance_date = ((newVal.prod_acceptance_date) ? this.formatDate(newVal.prod_acceptance_date,'Y-m-d') : null)
                this.form.prod_loan_officer_id = newVal.prod_loan_officer_id
                this.form.prod_submitted_date = ((newVal.prod_submitted_date) ? this.formatDate(newVal.prod_submitted_date,'Y-m-d') : null)
                this.form.prod_ins_add_cost = newVal.product_detail.prod_ins_add_cost
                this.prodSSADetails = newVal.prod_ssa_detail;
            },
            immediate: true
        },
        'form.status': {
            // handler(newStatus, oldStatus) {
            //     if (newStatus === 'Approved' && newStatus !== oldStatus) {
            //         const selectedSSA = this.prodSSADetails;
            //         if (selectedSSA) {
            //             this.sendApprovalEmailToSSA(selectedSSA.name, selectedSSA.email);
            //         }
            //     }
            // },
            // immediate: false 
            handler(newStatus, oldStatus) {
                if (newStatus === 'Approved' && newStatus !== oldStatus) {
                    this.sendApprovalEmail();
                } 
                else if (newStatus === 'Declined by Client' && newStatus !== oldStatus) {
                    this.sendRejectionEmail();
                } 
                else if (newStatus === 'Pending Application' && newStatus !== oldStatus) {
                    this.sendPendingApprovalEmail();
                }
            },
            immediate: false,
        },
        'form.premium_pa':{
            handler(newVal){
                this.form.premium_pm = parseFloat(newVal) / 12
            }
        }
    },
    computed:{
        ...mapState(useAuthStore, ['auth_user']),
				...mapState(useAccessControlStore, ['userLoanOfficerList']),
				...mapState(useProductStore, ['list_sub_insurance_status']),
				isApprovedBank(){
					return INSURANCE_APPROVED_STATUS.indexOf(this.form.status) !== -1;
				}
    },
    methods: {
    	...mapActions(useProductStore, ['checkGenerateCommission']),
      ...mapActions(useMessagingStore, ['sendEmail']),
      ...mapActions(useNotificationStore, ['createNotification','fetchEmailTemplate', 'fetchNotificationTemplate']),
        async handleStatusChange(newStatus) {
            try {
                // Fetch the notification template using the trigger point 'LEAD_STATUS_CHANGE'
                const notificationTemplate = await this.fetchNotificationTemplate('CASE_STATUS_CHANGE');
                if (notificationTemplate && notificationTemplate.is_active) { 
                let message = notificationTemplate.notif_temp_message

                // Construct the notification content
                let contentNotification = {
                  noti_message: "Case #"+ this.product.prod_id +" : "+message+" "+newStatus,
                  noti_url: window.location.origin + '/casesListings',
                    microservice_code: 'product',
                    noti_related_type: 'product',
                    noti_related_id: this.product.prod_id,
                };

                // Get recipients from the template
                const recipients = notificationTemplate.notif_temp_receiver.split(',').map(id => parseInt(id.trim(), 10));

                for (const recipient of recipients) {
                          if (!isNaN(recipient)) { // Check if recipient is a valid integer
                            let notification = { ...contentNotification, noti_user_id: recipient };
                            
                            // let notification = { ...contentNotification, noti_user_id: recipients }

                            this.createNotification(notification)
                        }
                }   
              }
                this.notifySuccess('Notification sent successfully.');

            } catch (error) {
                console.error('Failed to send notification:', error);
                this.notifyError('Failed to send notification.');
            }
        },
        async sendEmailToLoanOfficer(loanOfficerName, loanOfficerEmail) {
            const emailData = {
                to: loanOfficerEmail, 
                subject: `New Case Assigned: [ Insurance - ${this.product.prod_id} ]`,
                body: `Dear ${loanOfficerName},\n\nA new case has been assigned to you. Please review the details at your earliest convenience.\n\nThank you,\nFintos Advice Consultancy Sdn Bhd`
            };
            try {
                const response = await axios.post( services.product + 'send-email', emailData , {headers: getHeader()}); // Adjust the API endpoint as per your backend route
                console.log('Email sent successfully:', response);
            } catch (error) {
                console.error('Error sending email:', error);
            }
        },

        loanOfficerDetails() {
            const selectedLoanOfficer = this.userLoanOfficerList.find(officer => officer.id === this.form.prod_loan_officer_id);
            if (selectedLoanOfficer) {
                this.sendEmailToLoanOfficer(selectedLoanOfficer.name ,  selectedLoanOfficer.email);
            }
        },
      
        async sendPendingApprovalEmail() {
          try {
            const emailTemplate = await this.fetchEmailTemplate('CASE_PENDING_APPROVAL');
            if (emailTemplate && emailTemplate.is_active == 1) {

              const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

              // Prepare the email data
              const emailData = {
                to: recipients, // Array of email addresses
                subject: emailTemplate.notif_temp_title,
                body: emailTemplate.notif_temp_message
                .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
                .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
              };
              
              await this.sendEmail(emailData);
              this.notifySuccess('Pending Approval email sent successfully.');
            }
          } 
          catch (error) {
              console.error('Failed to send email:', error);
              this.errorFunction(error);
          }
        },
        async sendApprovalEmail() {
          try {
            const emailTemplate = await this.fetchEmailTemplate('CASE_APPROVE');
            if (emailTemplate && emailTemplate.is_active == 1) {

                const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

                // Prepare the email data
                const emailData = {
                  to: recipients, // Array of email addresses
                  subject: emailTemplate.notif_temp_title,
                  body: emailTemplate.notif_temp_message
                  .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
                  .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
                };

                await this.sendEmail(emailData);
                this.notifySuccess('Approval email sent successfully.');
              }
            } 
            catch (error) {
                console.error('Failed to send email:', error);
                this.errorFunction(error);
            }
          },
        async sendRejectionEmail() {
          try {
          const emailTemplate = await this.fetchEmailTemplate('CASE_REJECT');
          if (emailTemplate && emailTemplate.is_active == 1) {

          const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

          // Prepare the email data
          const emailData = {
            to: recipients, // Array of email addresses
            subject: emailTemplate.notif_temp_title,
            body: emailTemplate.notif_temp_message
            .replace('{case_id}', this.product.prod_id) // Replace {case_id} with product ID
            .replace('{case_name}', this.product.prod_customer_name), // Replace {case_name} with customer name
          };

              await this.sendEmail(emailData);
              this.notifySuccess('Rejection email sent successfully.');
            }
          } 
          catch (error) {
              console.error('Failed to send email:', error);
              this.errorFunction(error);
          }
      },
        // async sendApprovalEmailToSSA(ssaName, ssaEmail) {
        //     const incsuranceId = this.product.prod_id;
        //     const emailData = {
        //         to: ssaEmail,
        //         subject: `Loan Approval Notification: [ Insurance - ${incsuranceId} ]`,
        //         body: `Dear ${ssaName},\n\nWe are pleased to inform you that the application for insurance ${incsuranceId} has been approved. Final approval details can be referred to in the system's last update.\n\nBest regards,\nFintos Advice Consultancy Sdn Bhd`
        //     };
        //     try {
        //         const response = await axios.post(services.product + 'send-email', emailData, { headers: getHeader() });
        //         console.log('Email sent successfully:', response);
        //     } catch (error) {
        //         console.error('Error sending email:', error);
        //     }
        // },
        async sendEmailToSSA(ssaName, ssaEmail) {
            const emailData = {
                to: ssaEmail, 
                subject: `Application Update Processing with [ Insurance - ${this.product.prod_id} ]`,
                body: `Dear ${ssaName},\n\nWe are pleased to inform that your client - ${this.product.prod_customer_name} application is currently being processed by ${this.form.bank_name} at ${this.form.prod_bnk_submission_date}.\n\nBest regards,\nFintos Advice Consultancy Sdn Bhd`
            };
            try {
                const response = await axios.post(services.product + 'send-email', emailData , {headers: getHeader()});
                console.log('Email sent successfully:', response);
            } catch (error) {
                console.error('Error sending email:', error);
            }
        },

        async onSubmissionDateChange() {
            const selectedSSA = this.prodSSADetails;
            // console.log(selectedSSA.name, selectedSSA.email);
            if (selectedSSA) {
                this.sendEmailToSSA(selectedSSA.name, selectedSSA.email);
            }
        },
        getInsuranceStatus(){
            axios.get(services.lookup + 'insurance_status', {headers: getHeader()})
            .then(res => {
                this.status = res.data.data.filter((item) => item.group === 'sub')
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        updateInsurance(){
            const status = this.list_sub_insurance_status.find((item) => item.status === this.form.status)
            let acceptance_date = (this.form.acceptance_date) ? this.form.acceptance_date+" 00:00:00" : null;

            if(!status || !status.parent){
                this.errorFunction(null, 'Status could not be found.')
                return
            }

            const insurance = {
                prod_customer_id: this.product.prod_customer_id,
                prod_customer_name: this.product.prod_customer_name,
                prod_type: this.product.prod_type,
                prod_customer_basket: this.product.prod_customer_basket,
                prod_status: this.product.prod_status,
                prod_agent_id: this.product.prod_agent_id,
                prod_agent_username: this.product.prod_agent_username,
                prod_main_status: status.parent.status,
                prod_status: status.status,
                prod_acceptance_date: acceptance_date,
                prod_submitted_date: this.form.prod_submitted_date ? this.form.prod_submitted_date+" 00:00:00" : null,
                prod_loan_officer_id: this.form.prod_loan_officer_id,
                product_detail: {                    
                    prod_ins_type: this.form.product_type,
                    prod_ins_package:this.form.package_name,
                    prod_ins_company:this.form.company_name,
                    prod_ins_premium_pa:this.form.premium_pa,
                    prod_ins_premium_pm:this.form.premium_pm,
                    prod_ins_premium_cover:this.form.premium_cover,
                    prod_ins_paid_by:this.form.paid_by,
                    prod_ins_add_cost: this.form.prod_ins_add_cost
                }
            }

            this.is_loading = true
            axios.post(services.product + 'product/'+this.product.prod_id, insurance, {headers: getHeader()})
                .then(res => {
                    this.is_loading = false
                    caseEventBus.$emit('refresh-cases')
                    this.notifySuccess('<b>Insurance Case</b> - Successfully Updated.')
										this.checkGenerateCommission(this.product,'insurance_status',this.form.status)
                })
                .catch(e => {
                    this.is_loading = false
                    this.errorFunction(e)
                })
        }
    }
}
</script>